
import http from './http'

export default {
  stall: {
    get (id) {
      return http.get('/stall/get', { id: id })
    },
    getList (search, pageConfig) {
      return http.get('/stall/getlist', {
        shopId: search.shopId,
        merchantId: search.merchantId,
        keyword: search.keyword,
        stallClassId: search.stallClassId,
        pageIndex: pageConfig.pageIndex,
        pageSize: pageConfig.pageSize
      })
    },
    getTypeList () {
      return http.get('/stall/gettypelist')
    },
    create (model) {
      return http.post('/stall/create', model)
    },
    update (model) {
      return http.post('/stall/update', model)
    },
    delete (id) {
      return http.post('/stall/delete', id)
    }
  },
  stallTag: {
    get (id) {
      return http.get('/stall/stalltag/get', { id: id })
    },
    getList () {
      return http.get('/stall/stalltag/getlist')
    },
    create (model) {
      return http.post('/stall/stalltag/create', model)
    },
    update (model) {
      return http.post('/stall/stalltag/update', model)
    },
    delete (id) {
      return http.post('/stall/stalltag/delete', id)
    }
  },
  stallClass: {
    get (id) {
      return http.get('/stall/stallclass/get', { id: id })
    },
    getList () {
      return http.get('/stall/stallclass/getlist')
    },
    create (model) {
      return http.post('/stall/stallclass/create', model)
    },
    update (model) {
      return http.post('/stall/stallclass/update', model)
    },
    delete (id) {
      return http.post('/stall/stallclass/delete', id)
    }
  },
  stallContract: {
    get (id) {
      return http.get('/stall/stallcontract/get', { id: id })
    },
    getList (search, pageConfig) {
      return http.get('/stall/stallcontract/getlist', {
        shopId: search.shopId,
        stallId: search.stallId,
        merchantId: search.merchantId,
        startDate1: search.startDate[0],
        startDate2: search.endDate[1],
        endDate1: search.startDate[0],
        endDate2: search.endDate[1],
        pageIndex: pageConfig.pageIndex,
        pageSize: pageConfig.pageSize
      })
    },
    create (model) {
      return http.post('/stall/stallcontract/create', model)
    },
    update (model) {
      return http.post('/stall/stallcontract/update', model)
    },
    delete (id) {
      return http.post('/stall/stallcontract/delete', id)
    }
  },
  stallUtilityBill: {
    get (id) {
      return http.get('/stall/stallutilitybill/get', { id: id })
    },
    getList (search, pageConfig) {
      return http.get('/stall/stallutilitybill/getlist', {
        shopId: search.shopId,
        stallId: search.stallId,
        pageIndex: pageConfig.pageIndex,
        pageSize: pageConfig.pageSize
      })
    },
    create (model) {
      return http.post('/stall/stallutilitybill/create', model)
    },
    update (model) {
      return http.post('/stall/stallutilitybill/update', model)
    },
    delete (id) {
      return http.post('/stall/stallutilitybill/delete', id)
    }
  },
  stallContractRental: {
    get (id) {
      return http.get('/stall/stallcontractrental/get', { id: id })
    },
    getList (search, pageConfig) {
      return http.get('/stall/stallcontractrental/getlist', {
        shopId: search.shopId,
        merchantId: search.merchantId,
        stallId: search.stallId,
        finished: search.finished,
        startDate: search.startDate,
        endDate: search.endDate,
        pageIndex: pageConfig.pageIndex,
        pageSize: pageConfig.pageSize
      })
    },
    update (model) {
      return http.post('/stall/stallcontractrental/update', model)
    }
  },
  stallProduct: {
    get (id) {
      return http.get('/stall/stallproduct/get', { id: id })
    },
    getByProductId (stallId, productId) {
      return http.get('/stall/stallproduct/getbyproductid', {
        stallId: stallId,
        productId: productId
      })
    },
    getList (search, pageConfig) {
      return http.get('/stall/stallproduct/getlist', {
        stallId: search.stallId,
        keyword: search.keyword,
        productClassId: search.productClass,
        pageIndex: pageConfig.pageIndex,
        pageSize: pageConfig.pageSize
      })
    },
    getListByClass (stallId, productClassId) {
      return http.get('/stall/stallproduct/getlistbyclass', {
        stallId: stallId,
        productClassId: productClassId
      })
    },
    addProduct (model) {
      return http.post('/stall/stallproduct/addproduct', model)
    },
    addProductByClass (model) {
      return http.post('/stall/stallproduct/addproductbyclass', model)
    },
    changePrice (model) {
      return http.post('/stall/stallproduct/changeprice', model)
    },
    delete (ids) {
      return http.post('/stall/stallproduct/delete', ids)
    },
    deleteAll (id) {
      return http.post('/stall/stallproduct/deleteall', id)
    },
    resetDownload (id) {
      return http.post('/stall/stallproduct/resetdownload', id)
    },
    import (model) {
      return http.post('/stall/stallproduct/import', model)
    }
  },
  stallProductPriceLog: {
    getList (search, pageConfig) {
      return http.get('/stall/stallproductpricelog/getlist', {
        stallId: search.stallId,
        keyword: search.keyword,
        startDate: search.date[0],
        endDate: search.date[1],
        productClassId: search.productClass,
        pageIndex: pageConfig.pageIndex,
        pageSize: pageConfig.pageSize
      })
    }
  },
  stallQuery: {
    getStallClassSummary (shopId) {
      return http.get('/stall/stallquery/getstallclasssummary', {
        shopId: shopId
      })
    },
    getStallUsedList (search, pageConfig) {
      return http.get('/stall/stallquery/getstallusedlist', {
        shopId: search.shopId,
        classId: search.stallClassId,
        inUse: search.inUse,
        pageIndex: pageConfig.pageIndex,
        pageSize: pageConfig.pageSize
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/api/stall.js